import Output       from '../Output';
import IncludeAlpha from '../Options/IncludeAlpha';

export default class Rgb extends Output {

    static availableOptions = [IncludeAlpha];

    output() {
        let color = this.subject.color;

        return `rgb(${color.red}, ${color.green}, ${color.blue})`
    }

}